<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col md="6">
                    <div class="float-left">
                      <h5 class="mt-2 mr-3">Batch Summary</h5>
                    </div>
                  </b-col>
                  <b-col md="2" class="text-right pr-0">
                    <b-button variant="outline-danger"
                      >Status: Pending</b-button
                    >
                  </b-col>
                  <b-col md="4">
                    <b-input-group class="box-shadow">
                      <b-input-group-text slot="prepend" class="search-icon">
                        <font-awesome-icon :icon="['fas', 'search']" />
                      </b-input-group-text>
                      <b-form-input
                        v-model="search"
                        placeholder="Search Orders..."
                        v-on:keyup.enter="searchbar"
                        class="search"
                        autocomplete="off"
                        :disabled="$loading"
                        v-shortkey.focus="['ctrl', 's']"
                        autofocus
                      ></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>
      <section>
        <b-container fluid>
          <div class="pill box-shadow p-3 mt-2 detail">
            <b-row>
              <b-col lg="2" md="3"
                ><label class="mb-0">Batch Code</label>
                <p>BA000012345678</p></b-col
              >
              <b-col lg="2" md="3"
                ><label class="mb-0">Name</label>
                <p>Name of the Batch</p></b-col
              >
              <b-col lg="4" md="6"
                ><label class="mb-0">Description</label>
                <p>Orders placed on Amazon in first week of August</p></b-col
              >
              <b-col lg="1" md="3"
                ><label class="mb-0">Orders</label>
                <p>6</p></b-col
              >
              <b-col lg="1" md="3"
                ><label class="mb-0">Total Items</label>
                <p>40</p></b-col
              >
              <b-col lg="2" md="4"
                ><label class="mb-0">Total Amount</label>
                <p>₹24,906.00</p></b-col
              >
            </b-row>
            <b-row>
              <b-col lg="2" md="3"
                ><b-button block variant="primary">Confirm Orders</b-button></b-col
              >
              <b-col lg="2" md="3"
                ><b-button block>Edit Batch Information</b-button></b-col
              >
              <b-col lg="2" md="3"
                ><b-button block>Add More Orders</b-button></b-col
              >
              <b-col lg="2" md="3"
                ><b-button block>Edit Orders</b-button></b-col
              >
              <b-col lg="2" md="3"
                ><b-button block variant="danger"
                  >Cancel all Orders</b-button
                ></b-col
              >
              <b-col lg="2" md="3"
                ><b-button block variant="danger"
                  >Edit Batch Information</b-button
                ></b-col
              >
            </b-row>
          </div>
        </b-container>
      </section>
      <section>
        <b-container fluid>
          <b-row class="mt-2">
            <b-col lg="8">
              <b-button
                class="mr-2 toggle-layout float-left"
                @click="listView = !listView"
              >
                <span v-if="listView"
                  ><font-awesome-icon :icon="['fas', 'th']" class="mr-2" />Grid
                  View</span
                >
                <span v-else
                  ><font-awesome-icon
                    :icon="['fas', 'bars']"
                    class="mr-2"
                  />List View</span
                >
              </b-button>
              <FilterButton :searchAble="false">
                <template slot="btn"
                  >Date:
                  <span v-if="selectedDate.length == 0"> All</span>
                  <span v-text="selectedDate"></span>
                </template>
                <template slot="body">
                  <ul class="m-0 filter-dropdown">
                    <li v-for="(options, i) in filter.date" :key="i">
                      <label
                        class="w-100 d-flex justify-content-between align-item-center custom-check-two"
                      >
                        {{ options.name }}
                        <input
                          type="checkbox"
                          :value="options.name"
                          v-model="selectedDate"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </li>
                  </ul>
                </template>
              </FilterButton>

              <FilterButton :searchAble="false">
                <template slot="btn"
                  >Sort by:
                  <span v-if="selectedSort.length == 0"> Newest First</span>
                  <span v-text="selectedSort"></span>
                </template>
                <template slot="body">
                  <ul class="m-0 filter-dropdown">
                    <li v-for="(options, i) in filter.sort" :key="i">
                      <label
                        class="w-100 d-flex justify-content-between align-item-center custom-check-two"
                      >
                        {{ options.name }}
                        <input
                          type="checkbox"
                          :value="options.name"
                          v-model="selectedSort"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </li>
                  </ul>
                </template>
              </FilterButton>
            </b-col>
            <b-col lg="4" class="text-right">
              <b-button
                variant="danger"
                size="sm"
                style="padding:0.525rem 1rem"
                disabled
                >Reset Filter</b-button
              >
              <b-button
                variant="danger"
                size="sm"
                style="padding:0.525rem 1rem"
                v-if="newBatch == true"
                :disabled="selectedBatch.length == ''"
                @click="clearSelection()"
                class="mx-2"
                >Clear Selected</b-button
              >
              <b-button
                size="sm"
                v-if="newBatch == true"
                class="grey-btn"
                style="padding:0.555rem 1rem !important "
                >Select All</b-button
              >
            </b-col>
          </b-row>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div v-bar>
            <div>
              <div class="customer-info table-dark-bg box-shadow p-2 mt-2">
                <div v-if="batchList != '' && listView == false">
                  <!-- List View-->
                  <div
                    class="pill p-3 box-shadow mb-2"
                    v-for="item in batchList"
                    :key="item.id"
                    :class="{
                      completed:
                        item.status == 'packed' ||
                        item.status == 'confirmed' ||
                        item.status == 'item_picked' ||
                        item.status == 'being_packed',
                      pending: item.status == 'pending',
                      shipped: item.status == 'shipped',
                      hidden:
                        item.status != selectedBatchStatus &&
                        selectedBatchStatus !== '',
                    }"
                  >
                    <b-row class="w-100" style="display: inline-table;">
                      <b-col style="display: table-cell; width: 14%;">
                        <div class="d-flex">
                          <div class="custom-check" v-if="newBatch == true">
                            <input
                              type="checkbox"
                              :value="item.order_number"
                              :id="item.order_number"
                              v-model="selectedBatch"
                              @click="clickBatch(item)"
                            />
                            <label :for="item.order_number"></label>
                          </div>
                          <div class="ml-2">
                            <h6
                              class="mb-1 fw-normal"
                              :class="{
                                'text-success ':
                                  item.status == 'confirmed' ||
                                  item.status == 'packed' ||
                                  item.status == 'item_picked' ||
                                  item.status == 'being_packed',
                                'text-danger': item.status == 'pending',
                                'text-muted': item.status == 'shipped',
                              }"
                            >
                              <span v-if="item.status == 'pending'"
                                >Pending</span
                              >
                              <span v-else-if="item.status == 'confirmed'"
                                >Confirmed</span
                              >
                              <span v-else-if="item.status == 'item_picked'"
                                >Items Picked</span
                              >
                              <span v-else-if="item.status == 'being_packed'"
                                >Being Packed</span
                              >
                              <span v-else-if="item.status == 'packed'"
                                >Packed</span
                              >
                              <span v-else-if="item.status == 'shipped'"
                                >Shipped</span
                              >
                            </h6>
                            <p v-text="item.date"></p>
                          </div>
                        </div>
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 10%;"
                      >
                        <label for class="mb-0">Order Number</label>
                        <p v-text="item.order_number"></p>
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 12%;"
                      >
                        <label for class="mb-0">Source</label>
                        <p v-text="item.source"></p>
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 14%;"
                      >
                        <label for class="mb-0">Customer Name</label>
                        <p v-text="item.fname + item.lname"></p>
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 10%;"
                      >
                        <label for class="mb-0">Payment Status</label>
                        <p
                          :class="{
                            'text-danger': item.payment_status == 'Incomplete',
                          }"
                          v-text="item.payment_status"
                        ></p>
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 10%;"
                      >
                        <label for class="mb-0">Mode of Payment</label>
                        <p
                          :class="{ 'text-muted': item.MOP == 'None' }"
                          v-text="item.MOP"
                        ></p>
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 5%;"
                      >
                        <label for class="mb-0">Items</label>
                        <p v-text="item.items"></p>
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 2%;"
                      >
                        <label for class="mb-0">Total Amount</label>
                        <p v-text="item.total"></p>
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <div v-else>
                  <div class="d-flex flex-wrap">
                    <b-col
                      md="4"
                      v-for="item in batchList"
                      :key="item.id"
                      class="pl-0"
                    >
                      <div
                        class="pill p-3 box-shadow mb-3 "
                        :class="{
                          completed:
                            item.status == 'packed' ||
                            item.status == 'confirmed' ||
                            item.status == 'item_picked' ||
                            item.status == 'being_packed',
                          pending: item.status == 'pending',
                          shipped: item.status == 'shipped',
                        }"
                      >
                        <b-row>
                          <b-col md="7">
                            <div class="d-flex status">
                              <div class="custom-check" v-if="newBatch == true">
                                <input
                                  type="checkbox"
                                  :value="item.order_number"
                                  :id="item.order_number"
                                  v-model="selectedBatch"
                                  @click="clickBatch(item)"
                                />
                                <label :for="item.order_number"></label>
                                <!-- </span> -->
                              </div>
                              <div class="ml-2">
                                <h6
                                  class="mb-1 fw-normal"
                                  :class="{
                                    'text-success ':
                                      item.status == 'confirmed' ||
                                      item.status == 'packed',
                                    'text-danger': item.status == 'pending',
                                    'text-muted': item.status == 'shipped',
                                  }"
                                >
                                  <span v-if="item.status == 'pending'"
                                    >Pending</span
                                  >
                                  <span v-else-if="item.status == 'confirmed'"
                                    >Confirmed</span
                                  >
                                  <span v-else-if="item.status == 'item_picked'"
                                    >Items Picked</span
                                  >
                                  <span
                                    v-else-if="item.status == 'being_packed'"
                                    >Being Packed</span
                                  >
                                  <span v-else-if="item.status == 'packed'"
                                    >Packed</span
                                  >
                                  <span v-else-if="item.status == 'shipped'"
                                    >Shipped</span
                                  >
                                </h6>
                                <p class="fs-12" v-text="item.date"></p>
                              </div>
                            </div>
                          </b-col>
                          <b-col md="5">
                            <label for class="mb-0 fs-11">{{
                              item.source
                            }}</label>
                            <p class="fs-12" v-text="item.order_number"></p>
                          </b-col>
                        </b-row>
                        <b-row class="mt-2">
                          <b-col md="3">
                            <label for class="mb-0 fs-11">Customer Name</label>
                            <p class="fs-12" v-text="item.fname"></p>
                          </b-col>
                          <b-col md="4">
                            <label for class="mb-0 fs-11"
                              >MOP
                              <span
                                class="text-danger"
                                v-if="item.MOP == 'None'"
                                >(Incomplete)</span
                              >
                            </label>
                            <p
                              class="fs-12"
                              :class="{ 'text-muted': item.MOP == 'None' }"
                              v-text="item.MOP"
                            ></p>
                          </b-col>
                          <b-col md="2">
                            <label for class="mb-0 fs-11">Items</label>
                            <p class="fs-12" v-text="item.items"></p>
                          </b-col>
                          <b-col md="2">
                            <label for class="mb-0 fs-11">Total Amount</label>
                            <p class="fs-12" v-text="item.total"></p>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </div>
                </div>
                <div
                  v-if="batchList.length === 0 || !notFound"
                  class="d-flex align-items-center justify-content-center"
                  style="height:100%"
                >
                  <h5 class="fw-normal" v-if="$loading == false">
                    No batch found.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import { mapState } from "vuex";
import FilterButton from "../components/FilterButton.vue";

// import * as msg from "../message";

export default {
  name: "batch-summary",
  components: {
    Dashboard,
    Loading,
    FilterButton,
  },
  mounted() {},
  watch: {},
  created() {},
  computed: {
    ...mapState({
      state: (state) => state,
    }),
  },

  data() {
    return {
      selectedDate: [],
      selectedStatus: [],
      selectedMOP: [],
      selectedSort: [],
      selected: null,
      loading: true,
      searchableName: true,
      isContentShow: false,
      searchedTerm: "",
      Invoices: [],
      newBatch: false,
      listView: false,
      // searchInvoices: [],
      batchList: "",
      isShow: false,
      isSearchShow: false,
      search: "",
      startDate: "",
      finalDate: "",
      specDay: "",
      specMonth: "",
      specYear: "",
      endDate: "",
      rangePopup: true,
      invoicedate: "",
      notFound: true,
      showSearchTerm: false,
      selectedBatch: [],
      selectedBatchStatus: "",
      // batchList: [
      //   {
      //     status: "pending",
      //     date: "01 Aug 2020 00:00:00",
      //     order_number: "OD12345678901234",
      //     source: "In-store Order",
      //     fname: "Firstname",
      //     lname: "Lastname",
      //     payment_status: "Incomplete",
      //     MOP: "None",
      //     items: "4",
      //     total: "₹16,906.00",
      //   },
      //   {
      //     status: "pending",
      //     date: "01 Aug 2020 00:00:00",
      //     order_number: "OD12345678901235",
      //     source: "In-store Order",
      //     fname: "Firstname",
      //     lname: "Lastname",
      //     payment_status: "Complete",
      //     MOP: "Paytm, Cash",
      //     items: "10",
      //     total: "₹3,793.00",
      //   },
      //   {
      //     status: "pending",
      //     date: "01 Aug 2020 00:00:00",
      //     order_number: "OD12345678901236",
      //     source: "Omnichannel Source",
      //     fname: "Firstname",
      //     lname: "Lastname",
      //     payment_status: "Complete",
      //     MOP: "Cash",
      //     items: "24",
      //     total: "₹596.00",
      //   },
      // ],
      filter: {
        date: [
          {
            key: "today",
            name: "Today",
          },
          {
            key: "yesterday",
            name: "Yesterday",
          },
          {
            key: "last_week",
            name: "Last 7 Days",
          },
          {
            key: "specific_day",
            name: "Day..",
          },
          {
            key: "specific_month",
            name: "Month..",
          },
          {
            key: "specific_year",
            name: "Year..",
          },
          {
            key: "date_range",
            name: "Select Date Range",
          },
        ],
        status: "",
        mop: "",
        sort: "",
      },
      requestFilter: {
        date: "",
        sort: "",
        mop: "",
        status: "",
        filter_format: [],
        date_range: "",
      },
    };
  },
  methods: {
    clickBatch(e) {
      this.selectedBatchStatus = e.status;
    },
    clearSelection() {
      this.selectedBatch = [];
      this.selectedBatchStatus = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.grid-view {
  .pill {
    padding-left: 40px !important;
    .status {
      margin-left: -26px;
    }
  }
}
.toggle-layout {
  background: $dark-card-title-header !important;
  color: #606060 !important;
  border: 1px solid transparent;
  .fa-bars {
    font-size: 13px;
  }
}
.theme-dark .customer-info {
  background-color: #202020 !important;
  .custom-select {
    border: none !important;
  }
}
.btn-success.disabled,
.btn-success:disabled {
  background: #808080;
  border-color: #808080;
}

.theme-light .table-dark-bg {
  background: $grey-btn-bg;
  height: calc(100vh - 257px);
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
}
.theme-light .table-dark-bg.full,
.theme-dark .table-dark-bg.full {
  height: calc(100vh - 65px);
}
.theme-dark .table-dark-bg {
  height: calc(100vh - 257px);
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
}

.pill {
  border-radius: 5px;
  background: $white-color;
  position: relative;
  &.detail {
    &:hover {
      opacity: 1;
    }
  }
  &.hidden {
    opacity: 0.3;
    &:hover {
      opacity: 0.3;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  &:before {
    width: 5px;
    height: 100%;
    left: 0;
    top: 0;
    content: "";
    position: absolute;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  .return {
    color: #6699cc;
  }
}

h4 {
  color: $mid-grey;
}
h5 {
  color: $grey-color;
  span {
    color: $dark-card-text;
  }
}

.completed.pill {
  &:before {
    background: $success-btn;
  }
}
.pending.pill {
  &:before {
    background: $danger-dark;
  }
}
.shipped.pill {
  &:before {
    background: $dark-card-text;
  }
}
.completed h6 span {
  color: $success-btn;
}
.search-term-badge {
  font-weight: normal;
  font-size: 12px;
}
.header-elements .form-control:focus {
  background-color: #fff !important;
  border: 1px transparent !important;
}
</style>
